import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  logVoiceCallsDiagnosticsOnce,
  registerVoiceCallsDiagnosticsOnWindow
} from '../../utils/voiceCallsDiagnostics';
import { canUserMakeCalls, canUserReceiveCalls } from '../../utils/callsPermissionsUtils';

/**
 * Voice/Fonema call setup diagnostics — mount from CallManager only (not App shell).
 *
 * @param {'voice'|'fonema'|null|undefined} provider
 * @param {{ callsBalanceOk?: boolean }} [options]
 */
export default function useVoiceCallsDiagnostics(provider, options = {}) {
  const { callsBalanceOk = true } = options;
  const { retailer_info: retailerInfo } = useSelector(
    (state) => state.retailerUsersReducer
  );
  const currentRetailerUser = useSelector((state) => state.mainReducer?.currentRetailerUser);

  useEffect(() => {
    if (!retailerInfo?.id) return undefined;

    const canMakeCalls = canUserMakeCalls(currentRetailerUser);
    const canReceiveCalls = canUserReceiveCalls(currentRetailerUser);
    const shouldStartVoiceRuntime = provider === 'voice';

    logVoiceCallsDiagnosticsOnce(retailerInfo, {
      showHelpCenter: true,
      shouldMountCallManager: callsBalanceOk,
      shouldStartVoiceRuntime,
      canMakeCalls,
      canReceiveCalls,
      retailerUserId: currentRetailerUser?.id ?? null
    });
    registerVoiceCallsDiagnosticsOnWindow(retailerInfo);

    return undefined;
  }, [
    retailerInfo,
    provider,
    currentRetailerUser,
    callsBalanceOk
  ]);
}
